import type { PresetProfile, Vendor, BedrockRegionKey } from '@/types'

export const BEDROCK_REGION_MAP: Record<BedrockRegionKey, { prefix: string; region: string }> = {
  US:     { prefix: 'us.',     region: 'us-east-1' },
  EU:     { prefix: 'eu.',     region: 'eu-west-1' },
  AP:     { prefix: 'au.',     region: 'ap-southeast-2' },
  Global: { prefix: 'global.', region: 'us-east-1' },
}

/**
 * Categorize a preset profile into a vendor based on its profileType field.
 * - Contains "direct" → anthropic-direct
 * - Contains "grok" → grok
 * - Everything else → bedrock
 */
export function getVendorFromPreset(preset: PresetProfile): Vendor {
  if (preset.profileType?.toLowerCase().includes('direct')) return 'anthropic-direct'
  if (preset.profileType?.toLowerCase().includes('grok')) return 'grok'
  return 'bedrock'
}

/**
 * Filter presets by active vendors.
 * Guardrail presets are shown alongside regular Bedrock presets when Bedrock vendor is active.
 */
export function filterPresetsByVendors(
  presets: PresetProfile[],
  vendors: Set<Vendor>
): PresetProfile[] {
  return presets.filter(p =>
    vendors.has(getVendorFromPreset(p))
  )
}

/**
 * Rewrite a Bedrock preset's model ID prefix and region for the given region key.
 */
export function applyBedrockRegion(preset: PresetProfile, regionKey: BedrockRegionKey): PresetProfile {
  const { prefix, region } = BEDROCK_REGION_MAP[regionKey]
  const baseModelId = preset.modelId?.replace(/^(us|eu|ap|au|global)\./, '') ?? ''
  return { ...preset, modelId: `${prefix}${baseModelId}`, region }
}
